import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { LoginParams } from '@m4u-angular/base/entities/BaseEntities';
import { Observable, of } from 'rxjs';
import { Utils } from '../helpers/Utils';
import { LoginService } from './login.service';
import { NavigatorService } from './navigator.service';
import { SessionService } from './session.service';
import { EnumLoginSecureKeyTypes } from './sysenums.enum';
import { SysGlobals } from './sysglobals';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private navigator: NavigatorService,
        private loginService: LoginService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.sessionService.IsLoggedIn) return of(true);

        const [returnUrl, returnUrlParamsSessionID] = this.getParams(state.url, 'SessionID', true) ;

        const currentSessionID = this.sessionService.GetSessionID();
        const paramsSessionID = this.navigator.GetQueryParams(this.navigator.IsCurrentRouteWindow()).SessionID;
        const sessionID = paramsSessionID || returnUrlParamsSessionID || currentSessionID;
        if (!Utils.IsEmpty(sessionID)) {
            const loginParams = new LoginParams;
            loginParams.SecureKey = sessionID;
            loginParams.SecureKeyType = EnumLoginSecureKeyTypes.Session;
            return this.loginService.DoLogin(loginParams, !!currentSessionID, !currentSessionID, 
                () => this.navigator.NavigateByUrl(returnUrl), () => this.goToLoginPage(returnUrl));
        }

        this.goToLoginPage(returnUrl);
        return of(false);
    }

    private goToLoginPage(returnUrl: string) {
        this.navigator.Navigate(['/system/login'], { Language: SysGlobals.Language, ReturnUrl: returnUrl });
    }

    private getParams(url: string, key: string, isRemove: boolean = false) {
        const valueMatch = url.match(new RegExp('(._)?' + key + '=([^&]+)'));
        const value = valueMatch ? valueMatch[2] : null;
        
        if (isRemove) {
            const paramRegex = `(._)?${key}=[^&]+`;
            url = url.replace(new RegExp(`(\\?${paramRegex}$)|(&${paramRegex}$)`), ''); //ends url, just remove
            url = url.replace(new RegExp(`\\?${paramRegex}&`), '?'); // starts of query params
            url = url.replace(new RegExp(`&${paramRegex}&`), '&'); // middle of query params
        }
        
        return [url, value];
    }
}
